export class CloneUtils {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static cloneData = (object: any): any => JSON.parse(JSON.stringify(object));
}
